import { forwardRef } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';

import { Box, type BoxProps, Text } from '@frontend/components';

import { useTableStyles } from '../TableStylesContext';
import { getClassName } from './className';

export type TableTitleProps = BoxProps;

/**
 * A Table subcomponent to give the table a title.
 * - Place within the TableHeader.
 * - Wraps a Chakra-UI Text and responds to Table's size.
 */
export const TableTitle = forwardRef<TableTitleProps, 'div'>(
  ({ as = Text, children, className, ...restProps }: TableTitleProps, ref) => {
    const { title: titleStyles } = useTableStyles() ?? {};

    return (
      <Box
        ref={ref}
        as={as}
        __css={titleStyles}
        className={cx(getClassName('title'), className)}
        {...restProps}
      >
        {children}
      </Box>
    );
  },
);
TableTitle.displayName = 'TableTitle';
